module.exports = __webpack_public_path__ + "img/miaoli.2173a612.png";